import { render, staticRenderFns } from "./SelectOratore.vue?vue&type=template&id=3af21a4d&scoped=true&"
import script from "./SelectOratore.vue?vue&type=script&lang=js&"
export * from "./SelectOratore.vue?vue&type=script&lang=js&"
import style0 from "./SelectOratore.vue?vue&type=style&index=0&id=3af21a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af21a4d",
  null
  
)

export default component.exports